import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";
import {
  pageShellRoot,
  tablePaginationResponsive,
} from "../../styles/pageShell";

const useStyles = makeStyles((theme: Theme) => ({
  contentMain: pageShellRoot,

  onboardingRoot: {
    minWidth: 0,
    padding: "24px",
    backgroundColor: theme?.palette?.background?.default || colors.bgcolor,
    [down.md]: { padding: "20px 16px" },
    [down.sm]: { padding: "16px 12px" },
    ...tablePaginationResponsive,
  },

  containerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "24px",
    padding: "0 8px",
    [down.sm]: {
      flexDirection: "column",
      alignItems: "flex-start",
      marginBottom: "16px",
      padding: 0,
    },
  },

  divIconArrow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },

  card: {
    "&.MuiPaper-root": {
      backgroundColor: theme?.palette?.background?.paper || colors.WHITE,
      borderRadius: 16,
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.06)",
      border: `1px solid ${theme?.palette?.divider || "#e0e0e0"}`,
      overflow: "hidden",
    },
  },

  cardContent: {
    "&.MuiCardContent-root": {
      padding: 24,
      "&:last-child": { paddingBottom: 24 },
      [down.sm]: {
        padding: 16,
        "&:last-child": { paddingBottom: 16 },
      },
    },
  },

  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
  },

  statCard: {
    "&.MuiPaper-root": {
      minWidth: 0,
      borderRadius: 12,
      border: `1px solid ${theme?.palette?.divider || "#e0e0e0"}`,
      boxShadow: "none",
    },
  },

  statValue: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: 1.2,
    fontVariantNumeric: "tabular-nums",
    [down.sm]: { fontSize: 22 },
  },

  statLabel: {
    fontSize: 12,
    color: theme?.palette?.text?.secondary || "#6b7280",
    textTransform: "uppercase",
    letterSpacing: 0.4,
    marginTop: 4,
  },

  tabsBar: {
    borderBottom: `1px solid ${theme?.palette?.divider || "#e0e0e0"}`,
    marginBottom: 16,
  },

  tableWrap: {
    width: "100%",
    overflowX: "auto",
  },

  mono: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: 13,
  },

  monoSmall: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: 11,
    color: theme?.palette?.text?.secondary || "#6b7280",
  },

  /*
   * Etat vide : la seule page de l'application ou il est une bonne nouvelle.
   *
   * Les autres ecrans affichent "Aucune donnee" quand quelque chose a rate
   * (filtre trop etroit, requete en erreur). Ici zero ligne veut dire que
   * personne n'est bloque dehors, et le message doit le dire explicitement --
   * sinon l'exploitant se demande si l'ecran fonctionne.
   */
  emptyState: {
    padding: "48px 24px",
    textAlign: "center",
    color: theme?.palette?.text?.secondary || "#6b7280",
    fontSize: 14,
  },

  emptyStateOk: {
    color: theme?.palette?.success?.main || "#16a34a",
    fontWeight: 600,
    fontSize: 15,
    marginBottom: 6,
  },

  /*
   * Bandeau d'explication en tete de chaque onglet.
   *
   * Un exploitant qui tombe sur "Invitations bloquees" sans contexte ne sait ni
   * ce que la ligne signifie ni ce qu'il doit en faire. Une phrase par onglet
   * evite un aller-retour vers le developpeur a chaque fois.
   */
  hint: {
    fontSize: 13,
    lineHeight: 1.6,
    color: theme?.palette?.text?.secondary || "#6b7280",
    backgroundColor: theme?.palette?.action?.hover || "rgba(0,0,0,0.03)",
    borderRadius: 10,
    padding: "12px 14px",
    marginBottom: 16,
  },

  actionsCell: {
    whiteSpace: "nowrap",
    display: "flex",
    gap: 8,
    justifyContent: "flex-end",
  },

  dialogBody: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingTop: 8,
    minWidth: 380,
    [down.sm]: { minWidth: "auto" },
  },

  dialogNote: {
    fontSize: 12,
    lineHeight: 1.6,
    color: theme?.palette?.text?.secondary || "#6b7280",
  },
}));

export default useStyles;
